module.exports = __webpack_public_path__ + "static/media/umaCasaBlurredLogo.4c9082ae.png";